import { Tooltip } from "primereact/tooltip";
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */

export default function MenuItems5() {
    let history = useHistory();
    const items = [
        {
            label: 'Retiro',
            path: "/Social_benefitsProcess",
            index: 0,
        },
        {
            label: 'Nómina', index: 1,
            path: "/PayrollPaymentProcess",
        },
        {
            label: 'Vacaciones', index: 2,
            path: "/VacationProcess",
            icon: localStorage.getItem('vacation') === 'N' && "pi pi-lock",
        },
        {
            label: 'Adicionales', index: 3,
            path: "/AdditionalProcess",
            icon: localStorage.getItem('additional') === 'N' && "pi pi-lock",
        }
    ]
    return items
}